import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';

/** Long option lists scroll inside their section, so the drawer never grows past one screen. */
const List = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex flex-col gap-2 max-h-58 overflow-y-auto">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default List;